import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SecondLayout from "../../../layouts/SecondLayout";

const GccBusiness = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const pageTitle =
    language === "ar"
      ? ".السماء ليست الحد، بل عقلك هو الحد"
      : "The Sky is not the Limit, Your Mind Is.";
  const translations = {
    en: {
      heading1: "Mena Region including GCC region",
      text1:
        "A unique opportunity to distribute and get access to award winning beauty and skincare products to be distributed in the Mena region. These products are currently not being distributed in this region, so your sky is the limit.",
    },
    ar: {
      heading1: "منطقة الشرق الأوسط وشمال أفريقيا بما في ذلك دول الخليج",
      text1:
        "فرصة فريدة لتوزيع منتجات العناية بالبشرة والجمال الحائزة على جوائز والوصول إليها لتوزيعها في منطقة الشرق الأوسط وشمال أفريقيا. هذه المنتجات غير متوفرة حاليًا في هذه المنطقة، لذا فإن حدودك هي السماء.",
    },
  };

  const t = translations[language];
  const isArabic = language === "ar";
  return (
    <SecondLayout>
      <div className="container">
        <h2 className="about-me-title">{pageTitle}</h2>
      </div>

      <div className="opportunity-section">
        <div className={`opportunity-row ${isArabic ? "reverse" : ""}`}>
          <div className="opportunity-text light-bg">
            <h3>{t.heading1}</h3>
            <p>{t.text1}</p>
          </div>
          <div className="opportunity-img">
            <img src="/assets/images/Business/Business-2.jpg" alt="MENA" />
          </div>
        </div>
      </div>
    </SecondLayout>
  );
};

export default GccBusiness;
